<template>
  <div class="register-to-vote">
    <cac-page
      v-if="hasAdvocate"
      class="cac-page--has-advocate"
    >
      <cac-page-header
        slot="pre-content"
        :title="registerToVoteTitle"
      />

      <spinner
        v-if="loading"
        class="register-to-vote__spinner"
      />
      <div
        v-else-if="hasError"
        class="banner"
      >
        <span>{{ $t(error) }}</span>
      </div>
      <registered
        v-else-if="isRegisteredToVote"
        :reset-cookie-url="resetCookieUrl"
      />
      <not-registered
        v-else
        :online-registration-url="onlineRegistrationUrl"
        :registration-url="registrationUrl"
        :reset-cookie-url="resetCookieUrl"
      />
    </cac-page>
    <register-to-vote-banner v-else/>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { isEmpty as _isEmpty } from "lodash";
import STATE from "Constants/campaign/civicactioncenter/state";
import AdvocateActions from "Constants/campaign/civicactioncenter/advocateActions";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import RegisterToVoteBanner from "CivicActionCenterComponents/sections/RegisterToVote/RegisterToVoteBanner.vue";
import NotRegistered from "CivicActionCenterComponents/sections/RegisterToVote/NotRegistered.vue";
import Registered from "CivicActionCenterComponents/sections/RegisterToVote/Registered.vue";
import Spinner from "CivicActionCenterComponents/utilities/Spinner.vue";

const advocateRecordContext = `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_RECORD}`;
const hasAdvocateContext = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;

export default {
  name: "RegisterToVote",
  components: {
    CacPage,
    CacPageHeader,
    NotRegistered,
    Registered,
    RegisterToVoteBanner,
    Spinner
  },
  inject: {
    apiHelper: { from: "apiHelper" },
    redirectHelper: { from: "redirectHelper" }
  },
  data() {
    return {
      error: "",
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      advocateRecord: advocateRecordContext,
      hasAdvocate: hasAdvocateContext
    }),
    ...mapState(STATE.SCOPE_CAC, {
      voterInformation: STATE.VOTER_INFORMATION
    }),
    hasError() {
      return !_isEmpty(this.error) || this.loading;
    },
    isRegisteredToVote() {
      if (!_isEmpty(this.voterInformation.registrationStatus)) {
        return !!this.voterInformation.registrationStatus.registered;
      }

      return false;
    },
    onlineRegistrationUrl() {
      if (!_isEmpty(this.voterInformation.sosInformation)) {
        return this.voterInformation.sosInformation.url;
      }

      return "";
    },
    registerToVoteTitle() {
      return this.$t("cac.app.register_to_vote");
    },
    registrationUrl() {
      return this.voterInformation.registrationUrl || "";
    },
    resetCookieUrl() {
      return this.redirectHelper.getResetCookieUrl();
    }
  },
  watch: {
    hasAdvocate: "fetchVoterInformation",
    voterInformation: "handleVoterInformation"
  },
  async activated() {
    if (this.hasAdvocate) {
      this.fetchVoterInformation();

      await this.apiHelper.trackAdvocateAction(
        this.advocateRecord,
        AdvocateActions.REGISTER_TO_VOTE,
        AdvocateActions.PAPER_STEP_1
      );
    }
  },
  methods: {
    async fetchVoterInformation() {
      if (!this.hasAdvocate) {
        return;
      }

      this.error = "";
      this.loading = true;

      const response = await this.apiHelper.getVoterInformation(
        this.advocateRecord
      );

      if (!_isEmpty(response.error)) {
        this.error = "app.unknown_error_message";
        this.loading = false;
      }
    },
    handleVoterInformation() {
      if (_isEmpty(this.voterInformation.registrationStatus)) {
        this.loading = true;

        return;
      }

      this.loading = false;
    }
  }
};
</script>
